// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'HitPaw Online Ultimate',
  freeTimesLimitTitle: 'La prueba para la cuenta gratuita se agota hoy.',
  fileSizeLimitTitle:
    'El tamaño de los archivos de la versión gratuita no puede exceder los 20 MB.',
  freeImgCutoutTimesLimitTitle:
    'La oportunidad de prueba de hoy para la eliminación de fondos se ha agotado, por favor, actualice a Pro para acceder a todas las funciones premium',
  total: 'Total',
  enterCode: 'Introduzca el código',
  signUpToPurchaseBtn: 'Regístrese para comprar',
  goPurchseBtn: 'Ir a la compra',
  saveTips: 'Ahorre hasta un {{num}}%',
  discount: 'Descuento',
  priceWeek: '9,99€',
  priceMonth: '7,49€',
  priceYear: '3,75€',
  billedMonth: '29,99€ Pagado Mensualmente',
  billedYear: '179,99€ Pagado Anualmente',
  week: 'Semana',
  weekly: 'Semanalmente',
  monthly: 'Mensualmente',
  yearly: 'Anualmente',
  AlreadySubscribe: '¿Ya ha suscrito?',
  vipTips1: 'Sin límites de tamaño de archivo',
  vipTips2: 'Procesar cantidad de archivos sin límites',
  vipTips3: 'Cambiar fondos de imagen sin límites',
  vipTips4: 'Acceder a todas las herramientas gratuitas y funciones Premium',
  purchaseTips: 'Renovar automáticamente y cancelar en cualquier momento.',
  tips: 'Consejos:',
  promoCodeInvalidTips: 'Su código de promoción no es válido',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
